import {browserHistory} from 'react-router';
import api from '../../../api';
import moment from 'moment';
import { serverUrl, apiUrl } from '../../../../config/react'
import config from 'config';

import createStore from '../../../store/createStore'
import {changeLoading , snackAction} from '../../../routes/Main/modules/main'

export const HOME = 'HOME'
export const DOCTOR_INFO = 'DOCTOR_INFO'
export const NEW_PATIENT = 'NEW_PATIENT'
export const PATIENT_DETAIL  ='PATIENT_DETAIL'
export const TEXT_CHANGE = 'TEXT_CHANGE'
export const SEARCH = 'SEARCH'
export const PAGINATE = 'PAGINATE'
export const UPDATE_PATIENT_EXAMS = 'UPDATE_PATIENT_EXAMS'
const UPDATE_KEY = 'UPDATE_KEY'
export const OPEN_RESULTPOPUP = 'OPEN_RESULTPOPUP'
const limit = 10;
let dateformat = config.language.dateTimeFormat;

export function onTextChange(text){
	return (dispatch, getState) => {
		var patients = {...getState().patients};
		patients.searchValue = text;
		dispatch({
			type: TEXT_CHANGE,
			payload: patients
		})
	}
}
export function getPdf(testId){
  return (dispatch, getState) => {
    let locale = {...getState().locale};
    let newWin = window.open('','null','height=500,width=500,status=no, toolbar=no,menubar=no,location=no');
    return new Promise((resolve, reject) => {
      function reqListener () {
        let newBlob = new Blob([this.response], {type: "application/pdf"});
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        let urlCreator = window.URL || window.webkitURL;
        let data = urlCreator.createObjectURL(newBlob);

        if(!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
          let link = document.createElement('a');
          link.href = data;
          link.click();
        } else {
          newWin.location.href = data;
        }
        setTimeout(function(){
          // For Firefox it is necessary to delay revoking the ObjectURL
          urlCreator.revokeObjectURL(data);
        }, 100);
      }
      let oReq = new XMLHttpRequest();
      oReq.addEventListener("load", reqListener);
      oReq.open("POST", serverUrl + apiUrl + "/admin/pdf/" + testId + '?language=' + locale.options.defaultLanguage);
      oReq.setRequestHeader("authorization", "Basic "+localStorage.getItem('access_token'));
      oReq.setRequestHeader('Content-Transfer-Encoding', 'base64');
      oReq.responseType = "arraybuffer";
      oReq.send();
    })
  }
}

export function closeDialog(){
  return (dispatch, getState) => {
    closeEmailPopup();
    dispatch(updatePatientState("open", false));
  }
}

export function openEmailPopup(){
  return (dispatch, getState) => {
    var patients = {...getState().patients};
    patients.patientDetail.showEmailForm = true
    patients.patientDetail.emailSend = patients.patientDetail.currentTest && patients.patientDetail.currentTest.patient &&  patients.patientDetail.currentTest.patient.profile &&  patients.patientDetail.currentTest.patient.profile.email ?  patients.patientDetail.currentTest.patient.profile.email : null
    patients.patientDetail.subject = "Instapap Test Results"
    dispatch({
      type: PATIENT_DETAIL,
      payload: patients
    });
  }
}

export function closeEmailPopup(){
  return (dispatch, getState) => {
    let patients = {...getState().patients}
    patients.patientDetail.showEmailForm = false
    dispatch({
      type: PATIENT_DETAIL,
      payload: patients
    });
  }
}

export function sendEmail(testId){
  return (dispatch, getState) => {
    let locale = {...getState().locale};
    var patients = {...getState().patients};
    let data = {
      email: patients.patientDetail.emailSend,
      subject: patients.patientDetail.subject,
      body: patients.patientDetail.emailBody
    }
    api.post('/pdf/'+testId+'/email?language=' + locale.options.defaultLanguage, data, true)
    .then(response => {
      dispatch(updatePatientState("open", true));
    }, err => {
      dispatch(updatePatientState("showEmailForm", false));
      dispatch(updatePatientState("PopupContent", 'Send Email Fail'));
      dispatch(updatePatientState("sendEmail", true));
      dispatch(updatePatientState("showConfirmNextStep",true));
      // console.log(err);
    })
  }
}

export function onSearch(){
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			var patients = {...getState().patients};
			patients.lockPaginate = false;
			api.get('/admin/patients?doctor[]=' + patients.doctorId + '&limit=10&skip=0&name=' + String(patients.searchValue))
			.then(response => {
        if (document.querySelector("div[style='height: calc(100vh - 488px); overflow-x: hidden; overflow-y: auto;']")) {
          document.querySelector("div[style='height: calc(100vh - 488px); overflow-x: hidden; overflow-y: auto;']").scrollTop = 0;
        }
				patients.list = formatDataAfterGet(response.patients);
				dispatch({
					type: PATIENT_DETAIL,
					payload: patients
				});
				resolve(true);
			}, err => {
				// console.log(err);
			})
			resolve();
		})
	}
}

export function onLoad() {
	return (dispatch, getState) => {
		var a = {a:'abc'};
		dispatch({
			type: HOME,
			payload: a
		})
	}
}

export function newPatient(name) {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			var patients = {...getState().patients};
			patients.newPatient = name;
			dispatch({
				type: NEW_PATIENT,
				payload: patients
			});
			browserHistory.push('/addpatient');
			resolve();
		});
	}
}

export function patientDetail(doctorId, patientId) {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			var patients = {...getState().patients};
			// console.log(id)
			dispatch({
				type: PATIENT_DETAIL,
				payload: patients
			});
			browserHistory.push('/doctor/' + doctorId + '/patients/' + patientId);
			resolve();
		});
	}
}

export function getListPatient(doctorId) {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			api.get('/admin/patients?doctor[]=' + doctorId + '&limit=10&skip=0&name=' + String(''),'')
			.then(list => {
				// console.log(list);
				var patients = {...getState().patients};
				createStore.dispatch(changeLoading(true));
				patients.doctorId = doctorId;
				patients.searchValue = "";
				patients.list = formatDataAfterGet(list.patients);
				// console.log(patients.list);
				dispatch({
					type: PATIENT_DETAIL,
					payload: patients
				});
				resolve(true);
				createStore.dispatch(changeLoading(false));
			}, err => {
				reject(err);
			})
		});
	}
}
const formatDataAfterGet = (list) => {

	list.map((patient) => {
		patient.profile.age = getAge(new Date(patient.profile.dob));
		patient.profile.dob = moment(patient.profile.dob).format(dateformat);
		patient.profile.last_visit = patient.profile.last_visit ? {
			date: moment(patient.profile.last_visit).format(dateformat),
		} : null;
		if(typeof(patient.profile.next_visit)=="object"){
			switch(patient.profile.next_visit.status.name) {
				case 'In Progress': 	patient.profile.next_visit.status.date = '';
                    patient.profile.next_visit.status.className = 'progress-date';
										patient.profile.next_visit.status.text = '';
										break;
				case 'Due: ': 	patient.profile.next_visit.status.date = moment(patient.profile.next_visit.status.date).format(dateformat);
                patient.profile.next_visit.status.className = 'due-date';
								patient.profile.next_visit.status.text = 'Due:';
								break;
				default :
							if (new Date(patient.profile.next_visit.status.date) - new Date()  > 0) {
                patient.profile.next_visit.status.className = 'due-date';
							} else {
              	patient.profile.next_visit.status.className = 'past-date';
							}
							patient.profile.next_visit.status.date = moment(patient.profile.next_visit.status.date).format(dateformat);
							patient.profile.next_visit.status.text = '';
							break;
			}
		}
	});

	return list
}

export const paginate = () => {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			let patients = {...getState().patients};
			let query = `?doctor[]=${patients.doctorId}&limit=${limit}&skip=${patients.list.length}&name=${patients.searchValue}`;
			patients.lockPaginate = true;
			patients.isLoading = true;
			dispatch({
				type: PAGINATE,
				payload: patients
			});
			api.get('/admin/patients' + query, '', true)
			.then(list => {
				let patients = {...getState().patients};
				patients.isLoading = false;
				patients.list = [...patients.list,...formatDataAfterGet(list.patients)];
				patients.lockPaginate = (list.patients.length < limit) ? true : false;
				dispatch({
					type: PAGINATE,
					payload: patients
				});
				resolve()
			})
		});
	}
}

export const updateKey = (key, value) => {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			let patients = {...getState().patients};
			patients[key] = value
			dispatch({
				type: UPDATE_KEY,
				payload: patients
			});
			resolve()
		})
	}
}

export const openPopupResult = (patientDetail, show) => {
	return (dispatch, getState) => {
    let locale = {...getState().locale};
    dateformat = config.languages[locale.options.defaultLanguage].dateTimeFormat;
		return new Promise((resolve, reject) => {
			let patients = {...getState().patients};
			if (!!patientDetail.exams) {
				api.get('/admin/exams/' + patientDetail.exams, '', false)
				.then(response => {
          console.log(patientDetail, response);
					patientDetail.profile.date = {
						dob: patientDetail.profile.dob
					};
					patients.patientDetail = {
						profile: patientDetail.profile
					};

					patients.patientDetail.showResult = true;

					if(response.exams.imp && response.exams.imp.length > 0){
						response.exams.impCordinations = []
						response.exams.impCordinations.push(convertToCodinations(response.exams.imp[0]));
						response.exams.impCordinations.push(convertToCodinations(response.exams.imp[1]));
						response.exams.impCordinations.push(convertToCodinations(response.exams.imp[2]));
					}
					if(response.exams.optical && response.exams.optical.length > 0){
						response.exams.opticalCordinations = convertToCodinations(response.exams.optical)
					}


					patients.patientDetail.currentTest = response.exams;
          patients.patientDetail.currentTest.date_date = patients.patientDetail.currentTest.date ? moment(patients.patientDetail.currentTest.date).format(dateformat):moment(patients.patientDetail.currentTest.created_at).format(dateformat)
          patients.patientDetail.currentTest.date_time = patients.patientDetail.currentTest.date ? moment(patients.patientDetail.currentTest.date).add(1, "h").format("LT") : _buildTime(patients.patientDetail.currentTest.created_at)
					if(patients.patientDetail.currentTest.data){
						patients.patientDetail.currentTest.data.IMPcustom = []
		              if(patients.patientDetail.currentTest.data.IMP.length <16){
		                patients.patientDetail.currentTest.data.typeImage = 'FALSE'
		              }
		              if(patients.patientDetail.currentTest.data.IMP.length == 16){
		                patients.patientDetail.currentTest.data.typeImage = 'FOUR'
		              }
		              if(patients.patientDetail.currentTest.data.IMP.length > 16 && patients.patientDetail.currentTest.data.IMP.length <= 20){
		                patients.patientDetail.currentTest.data.typeImage = 'FIVE'
		              }
		              if(patients.patientDetail.currentTest.data.IMP.length > 20){
		                patients.patientDetail.currentTest.data.typeImage = 'SIX'
		              }
		              patients.patientDetail.currentTest.data.IMP.map((imp)=>{
		                let temp = 0;
		                imp.ID.map(k => {
		                  temp += parseInt(k);
		                })
		                patients.patientDetail.currentTest.data.IMPcustom.push(temp)
		              })
                }
					dispatch({
						type: OPEN_RESULTPOPUP,
						payload: patients
					});
					resolve();
				})
			}
		})
	}
}

function checkIndex (index, bound1, bound2){
  let rs = index
  if(index < bound1){
    rs = bound1
  }
  if(index >= bound2){
    rs = bound2 - 1
  }
  return rs;
}

function convertToCodinations(data){
  let result = [];
  // define step
  let min = data[0][0][0];
  let max = 0;

  data.map((line, k) =>{
    line.map((point, n) =>{
      if(point[0] >= max){
        max = point[0]
      }
      if(point[0] <= min){
        min = point[0]
      }
    })
  })
  let step = Math.ceil((max-min)/data.length)
  // transform graph
  data.map((line, i)=>{
    result.push({x: min + step *i})
  })

  data.map((line, i) => {
    line.map((point, j) => {
      let index = checkIndex(Math.ceil((point[0]-min)/step), 0, data.length);
      result[index]['y' + i] = point[1]
    })
  })
  return result
}

export function updateTestScreen (test, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      	let patients = {...getState().patients};
      	patients.patientDetail.showResult = value
      	patients.patientDetail.currentTest = test
      	dispatch({
	        type: OPEN_RESULTPOPUP,
	        payload: patients
      	})
      	resolve();
    })
  }
}

export function updatePatientState (key, value) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let patients = {...getState().patients};
			patients.patientDetail[key] = value;
      let exam = {};
      switch(key){
        case'nextStep':
          exam._id =  patients.patientDetail.currentTest._id;
          exam.patient = patients.patientDetail.currentTest.patient;
          if(patients.patientDetail.currentTest.next_step){
            patients.patientDetail.currentTest.next_step.test = value
          } else{
            patients.patientDetail.currentTest.next_step = {}
            patients.patientDetail.currentTest.next_step.test = value
          }
          exam.next_step = patients.patientDetail.currentTest.next_step
          apiUpdateExam([exam]).then(()=>{
            dispatch({
              type: UPDATE_PATIENT_EXAMS,
              payload: patients
            })
          })
          break;
        case'expectedResultDate':
          exam._id =  patients.patientDetail.currentTest._id;
          exam.patient = patients.patientDetail.currentTest.patient;
          if(patients.patientDetail.currentTest.next_step){
            patients.patientDetail.currentTest.next_step.expectedResultDate = value
          } else{
            patients.patientDetail.currentTest.next_step = {}
            patients.patientDetail.currentTest.next_step.expectedResultDate = value
          }
          exam.next_step = patients.patientDetail.currentTest.next_step
          apiUpdateExam([exam]).then(()=>{
            dispatch({
              type: UPDATE_PATIENT_EXAMS,
              payload: patients
            })
          })
        break;
        case 'nextApptDate':
          exam._id =  patients.patientDetail.currentTest._id;
          exam.patient = patients.patientDetail.currentTest.patient;
          let date = new Date (value);
          if( !patients.patientDetail.currentTest.follow_up){
            patients.patientDetail.currentTest.follow_up = new Date()
          }
          patients.patientDetail.currentTest.follow_up = new Date (patients.patientDetail.currentTest.follow_up);
          patients.patientDetail.currentTest.follow_up.setYear(date.getFullYear());
          patients.patientDetail.currentTest.follow_up.setMonth(date.getMonth());
          patients.patientDetail.currentTest.follow_up.setDate(date.getDate());
          exam.follow_up = new Date(patients.patientDetail.currentTest.follow_up);
          apiUpdateExam([exam]).then(()=>{
            dispatch({
              type: UPDATE_PATIENT_EXAMS,
              payload: patients
            })
          })
        break;
        case 'nextApptTime':
        exam._id =  patients.patientDetail.currentTest._id;
        exam.patient = patients.patientDetail.currentTest.patient;
          let time = new Date (value);
          if( !patients.patientDetail.currentTest.follow_up){
            patients.patientDetail.currentTest.follow_up = new Date()
          }
          patients.patientDetail.currentTest.follow_up = new Date (patients.patientDetail.currentTest.follow_up);
          patients.patientDetail.currentTest.follow_up.setHours(time.getHours());
          patients.patientDetail.currentTest.follow_up.setMinutes(time.getMinutes());
          exam.follow_up = new Date(patients.patientDetail.currentTest.follow_up);
          apiUpdateExam([exam]).then(()=>{
            dispatch({
              type: UPDATE_PATIENT_EXAMS,
              payload: patients
            })
          })
        break;
      }
      dispatch({
        type: OPEN_RESULTPOPUP,
        payload: patients
      })
      resolve();
    })
  }
}

export function updateTestNote (index, content){
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let patients = {...getState().patients};
      patients.patientDetail.currentTest.notes[index] = content;
      dispatch({
        type: OPEN_RESULTPOPUP,
        payload: patients
      })
      resolve();
    })
  }
}

export function updateExam (obj){
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let patients = {...getState().patients};
      let temp = {};
      if(obj){
        temp = obj;
      } else{
        temp.patient = patients.patientDetail.currentTest.patient;
        temp._id = patients.patientDetail.currentTest._id;
        temp.notes = patients.patientDetail.currentTest.notes;
      }
      delete patients.patientDetail.nextStep;
      delete patients.patientDetail.expectedResultDate;
      apiUpdateExam ([temp]).then(response => {
        dispatch({
          type : UPDATE_PATIENT_EXAMS,
          payload : patients
        })
        resolve()
      }, error => {
        dispatch({
          type : UPDATE_PATIENT_EXAMS,
          payload : error
        })
        reject()
      })
    })
  }
}

function apiUpdateExam (arrayExam){
  return new Promise((resolve, reject)=>{
    api.put('/exams/patients', arrayExam).then((response)=>{
      resolve(response);
    }, (error)=>{
      reject(error);
    })
  })
}

export function updatePatientStatus (empty) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      let patients = {...getState().patients};
      let newTest = {};
      let createFlag = true
      newTest.patient = patients.patientDetail.currentTest.patient;
      if(!empty){
        newTest.test_type = patients.patientDetail.newTestType ? patients.patientDetail.newTestType : null;
        newTest.status = patients.patientDetail.newTestStatus ? patients.patientDetail.newTestStatus : null;
        // if (newTest.results_date) {
        //   patients.patientDetail.newTestResultDate
        // }
        newTest.created_at = patients.patientDetail.newTestDate ? patients.patientDetail.newTestDate:null;

        newTest.files = patients.patientDetail.newTestFile ? [patients.patientDetail.newTestFile] : [];
        newTest.notes = {};
        newTest.notes.report = patients.patientDetail.newTestReportNote ? patients.patientDetail.newTestReportNote : '';
        newTest.notes.physical = '';
        newTest.notes.current_condition = '';

        Object.keys(newTest).map((key, i)=>{
          if(newTest[key] === null){
            createFlag = createFlag && false
          }
        })
      }
      if(empty){
        newTest.test_type = patients.patientDetail.nextStep ? patients.patientDetail.nextStep : null;
        createFlag = createFlag && newTest.test_type
        newTest.status = null;
        newTest.date = patients.patientDetail.expectedResultDate ? patients.patientDetail.expectedResultDate:null;
        createFlag = createFlag && (newTest.test_type != '')
      }

      if(createFlag){
        createExam(newTest).then((response) =>{
          delete patients.patientDetail.newTestType;
          delete patients.patientDetail.newTestStatus;
          delete patients.patientDetail.newTestResultDate;
          delete patients.patientDetail.newTestDate;
          delete patients.patientDetail.newTestFile;
          delete patients.patientDetail.newTestReportNote;
          delete patients.patientDetail.nextStep;
          delete patients.patientDetail.expectedResultDate;
          return patients.patientDetail.currentTest.patient;
        })
        .then((id) => {
          getExamsOfPatient(id).then((exams)=>{
            patients.patientDetail.exams = exams
            patients.patientDetail.exams.map((test)=>{
              if(test.data){

                test.data.IMPcustom = []
                if(test.data.IMP.length <16){
                  test.data.typeImage = 'FALSE'
                }
                if(test.data.IMP.length == 16){
                  test.data.typeImage = 'FOUR'
                }
                if(test.data.IMP.length > 16 && test.data.IMP.length <= 20){
                  test.data.typeImage = 'FIVE'
                }
                if(test.data.IMP.length > 20){
                  test.data.typeImage = 'SIX'
                }
                test.data.IMP.map((imp)=>{
                  let temp = 0;
                  imp.ID.map(k => {
                    temp += parseInt(k);
                  })
                  test.data.IMPcustom.push(temp)
                })
              }
            })
            dispatch({
              type : UPDATE_PATIENT_EXAMS,
              payload : patients
            })
            resolve();
          }, (error) =>{
            dispatch({
              type : UPDATE_PATIENT_EXAMS,
              payload : error
            })
            reject()
          })
        })
      } else{
        patients.patientDetail.showPopupConfirm = true
        delete patients.patientDetail.newTestType;
        delete patients.patientDetail.newTestStatus;
        delete patients.patientDetail.newTestResultDate;
        delete patients.patientDetail.newTestDate;
        delete patients.patientDetail.newTestFile;
        delete patients.patientDetail.newTestReportNote;

        dispatch({
          type : UPDATE_PATIENT_EXAMS,
          payload : patients
        })
      }
    })
  }
}

function getExamsOfPatient (patientId){
  return new Promise((resolve, reject) => {
    api.post('/exams/patients/' + patientId, {}).then(response => {
      response.exams.map((test, i)=>{
        test.created_at_date = test.created_at ? _buildDate(test.created_at) : ''
        test.created_at_time = test.created_at ? _buildTime(test.created_at) : ''
        test.results_date_date = test.results_date ? _buildDate(test.results_date) : ''
        test.results_date_time = test.results_date ? _buildTime(test.results_date) : ''
        test.date_date= test.date ? _buildDate(test.date) : ''
        test.date_time = test.date ? _buildTime(test.date) : ''
        if(test.imp && test.imp.length  > 0){
          test.impCordinations = []
          test.impCordinations.push(convertToCodinations(test.imp[0]));
          test.impCordinations.push(convertToCodinations(test.imp[1]));
          test.impCordinations.push(convertToCodinations(test.imp[2]));
        }
        if(test.optical && test.optical.length > 0 ){
          test.opticalCordinations = convertToCodinations(test.optical)
        }
      })
      response.exams = response.exams.filter((e)=>{
        return (((e.test_type.toLowerCase().localeCompare('instapap') !== 0) && e.status) || (e.test_type.toLowerCase().localeCompare('instapap') === 0) )
      })
      return response.exams
    })
    .then(exams => {
      resolve(exams)
    }, error => {
      reject(error)
    })
  })
}

function createExam (exam) {
  return new Promise((resolve, reject) => {
    api.post('/exams', exam).then((response)=>{
      resolve();
    }, (error)=>{
      console.log(error);
      reject();
    })
  })
}
function _buildDate(date){
  date = new Date(date);
  let m = moment(date).get('month') + 1;
  let y = moment(date).get('year');
  let d = moment(date).get('date');
  if(m <10){
    m = "0" + m;
  }
  if(d < 10){
    d = "0"+ d;
  }
  return d+'/'+m+'/'+y;;
}

function _buildTime(time, plusHour){
  plusHour = plusHour || false;

  if(!time){
    return "";
  }

  Date.prototype.addHours = function(h){
    this.setHours(this.getHours()+h);
    return this;
  }

  // let bd = time.slice(11, 16);
  let h = !plusHour ? (new Date(time)).getHours() : (new Date(time).addHours(plusHour)).getHours();
  let m = (new Date(time)).getMinutes();
  if(h< 10){
    h = "0" + h;
  }
  if(m < 10){
    m = "0" + m;
  }
  return h + ":" + m;
}
function getDateFormat(date){
	let year = date.getFullYear();
	let month = date.getMonth()+1;
	if(month<10){
		month = "0"+month;
	}
	let day = date.getDate();
	if(day<10){
		day = "0"+month;
	}
	return month+'-'+day+'-'+year;
}

function getDate(dt){
	var current_year = dt.getFullYear(),
	current_date = dt.getDate(),
	current_mins = current_mins < 10 ? "0"+current_mins: current_mins,
	current_hrs = current_hrs < 10 ? "0"+current_hrs: current_hrs,
	current_secs = current_secs < 10 ? "0"+current_secs: current_secs;
	current_date = current_date < 10 ? "0"+current_date: current_date;
	var current_month = (new Date(dt)).getMonth()+1;
	current_month = current_month < 10 ? "0"+current_month : current_month;
	return current_date+"/"+current_month+"/"+current_year;
}

function getTime(dt){
	var current_hrs = dt.getHours(),
	current_mins = dt.getMinutes(),
	current_secs = dt.getSeconds(),
	current_datetime;
	current_mins = current_mins < 10 ? "0"+current_mins: current_mins;
	current_hrs = current_hrs < 10 ? "0"+current_hrs: current_hrs;
	current_secs = current_secs < 10 ? "0"+current_secs: current_secs;
	return current_hrs+":"+current_mins+":"+current_secs;
}

function getTimeFormart(isoTime) {
  isoTime=getTime(isoTime);
  var hours   = parseInt(isoTime.substring(0, 2), 10),
      minutes = isoTime.substring(3, 5),
      ampm    = 'am';
  if (hours == 12) {
    ampm = 'pm';
  } else if (hours == 0) {
    hours = 12;
  } else if (hours > 12) {
    hours -= 12;
    ampm = 'pm';
  }
  return hours + ':' + minutes + '' + ampm;
}

function getAge(date) {
    var now = new Date();
    var age = now.getFullYear() - date.getFullYear();
    return age;
};

export function clearList() {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			var patients = {...getState().patients};
			patients.list = [];
			dispatch({
				type: PATIENT_DETAIL,
				payload: patients
			});
			resolve(true);
		});
	}
}

export function openPage(doctorId) {
	return (dispatch, getState) => {
    let locale = {...getState().locale};
    dateformat = config.languages[locale.options.defaultLanguage].dateTimeFormat;
		return new Promise((resolve, reject) =>  {
			createStore.dispatch(changeLoading(true));
			setTimeout(function() {
				Promise.all([api.get(`/admin/patients?doctor[]=${doctorId}&limit=${limit}&skip=0&name=` + String(''), '')])
				.then(result => {
					var patients = {...getState().patients};
					var list = result[0];
					patients.doctorId = doctorId;
					patients.searchValue = "";
          patients.list = formatDataAfterGet(list.patients);
          patients.lockPaginate = (list.patients.length < limit) ? true : false;
					dispatch({
						type: PATIENT_DETAIL,
						payload: patients
					});
					resolve(true);
					createStore.dispatch(changeLoading(false));
				}, err => {
					reject(err);
				})
			}, 100);
		})
	}
}
const ACTION_HANDLERS = {
	[HOME]: (state, action) => action.payload,
	[DOCTOR_INFO]: (state, action) => action.payload,
	[NEW_PATIENT]: (state, action) => action.payload,
	[PATIENT_DETAIL]: (state, action) => action.payload,
	[TEXT_CHANGE] : (state, action) => action.payload,
	[SEARCH] : (state, action) => action.payload,
	[PAGINATE] : (state, action) => action.payload,
	[UPDATE_KEY] : (state, action) => action.payload,
	[OPEN_RESULTPOPUP] : (state, action) => action.payload,
	[UPDATE_PATIENT_EXAMS] : (state, action) => action.payload
}
const initialState = {
	lockPaginate: false,
	isLoading: false,
	popupResult: false
}

export default function reducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/PatientDatabaseAdmin/modules/patients.js